import { ADMIN_BASE_URL, BASE_URL } from "../api_const";


export const NEW_CONSTRICTED_PROJECTS_BASE_URL = BASE_URL + "/services/new-project-constructed"
export const NEW_CONSTRUCTED_DETAIL_BY_ID = NEW_CONSTRICTED_PROJECTS_BASE_URL 
export const ALL_NEW_CONSTRUCTED_REQUESTS = NEW_CONSTRICTED_PROJECTS_BASE_URL + "/all"
